<template>
  <div v-if="isOpen" class="fixed inset-0 z-[200] flex items-start justify-center px-4 py-8 overflow-y-auto bg-black/50 backdrop-blur-sm" @click.self="closeModal">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl transform transition-all animate-in fade-in zoom-in duration-300 text-left relative overflow-visible">
      <!-- Modal Header -->
      <div class="px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between rounded-t-xl">
        <h2 class="text-lg font-bold m-0">{{ editItem ? 'Edit Item' : 'Item Registration' }}</h2>
        <button @click="closeModal" class="p-1 hover:bg-white/10 rounded-full transition-colors text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <!-- Modal Body -->
      <form @submit.prevent="handleSubmit" class="p-8">
         <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-2 gap-y-1">

    <!-- Item Code -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[0.85rem] font-semibold text-[#1e293b]">Item Code</label>
      <input 
        v-model="form.itemCode"
        type="text"
        placeholder="Enter item code"
        class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
        
      >
    </div>

    <!-- Category -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[0.85rem] font-semibold text-[#1e293b]">Category</label>
      <select 
        v-model="form.categoryId"
        class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm bg-white cursor-pointer"
        required
      >
        <option value="" disabled>Select Category</option>
        <option v-for="cat in categories" :key="cat.id" :value="cat.id">
          {{ cat.name }}
        </option>
      </select>
    </div>

    <!-- Item Name -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[0.85rem] font-semibold text-[#1e293b]">Item Name</label>
      <input 
        v-model="form.itemName"
        type="text"
        placeholder="Enter item name"
        class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
        required
      >
    </div>

    <!-- UOM Stock -->
  

 
    <!-- UOM Production -->
<div class="flex flex-col gap-1.5">
  <label class="text-[0.85rem] font-semibold text-[#1e293b]">U.O.M.Stock</label>
  <select 
    v-model="form.unit"
    class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm bg-white cursor-pointer"
    required
  >
    <option value="" disabled selected>Select Unit</option>
    <option v-for="unitPro in units" :key="unitPro" :value="unitPro">
      {{ unitPro }}
    </option>
  </select>
</div>

<div class="flex flex-col gap-1.5">
  <label class="text-[0.85rem] font-semibold text-[#1e293b]">U.O.M.Pro.</label>
  <select 
  disabled
    v-model="form.unitProduction"
    class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm bg-white cursor-pointer"
    required
  >
    <option value="" disabled selected>Select Unit</option>
    <option v-for="unitPro in unitsProductionOptions" :key="unitPro" :value="unitPro">
      {{ unitPro }}
    </option>
  </select>
</div>

  
  </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-1">
         

          <!-- Opening Stock Balance (multiple entries: balance, unit price, variant) -->
          <div class="flex flex-col gap-1.5 col-span-full mt-2 mb-2">
            <!-- <label class="text-[0.85rem] font-semibold text-[#1e293b]">Opening Stock Balance</label> -->
            <div class="flex items-center gap-2 text-[0.85rem] font-semibold text-[#1e293b]">
              <div class="flex-1 min-w-0">Opening Balance</div>
              <div class="flex-1 min-w-0">Unit Price</div>
              <div class="flex-1 min-w-0">
                Volume<span class="text-red-600">({{ form.unitProduction || '' }})</span>
              </div>
              <div class="flex-1 min-w-0">Expiry Date</div>
              <div class="w-10"></div>
            </div>
            <div class="flex flex-col gap-2">
              <div v-for="(entry, idx) in openingStockEntries" :key="idx" class="flex items-center gap-2 w-full">
                <input
                  v-model.number="entry.balance"
                  type="number"
                  placeholder="Balance"
                     step="any"
                      inputmode="decimal"
                  :readonly="!!props.editItem"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm flex-1 min-w-0"
                  :class="{ 'bg-gray-100 cursor-not-allowed': !!props.editItem }"
                />
                <input
                  v-model.number="entry.unitPrice"
                  type="number"
                  placeholder="Price"
                  step="any"
                  inputmode="decimal"
                  :readonly="!!props.editItem"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm flex-1 min-w-0"
                  :class="{ 'bg-gray-100 cursor-not-allowed': !!props.editItem }"
                />
                <input
                  v-model.number="entry.variant"
                  type="number"
                  :min="Number(entry.balance || 0) === 0 ? 0 : 1"
                  placeholder="Volume"
                  :readonly="!!props.editItem"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm flex-1 min-w-0"
                  :class="{ 'bg-gray-100 cursor-not-allowed': !!props.editItem }"
                />
                <input
                  v-model="entry.expiryDate"
                  type="date"
                  :min="todayDate"
                  :readonly="!!props.editItem"
                  class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm flex-1 min-w-0"
                  :class="{ 'bg-gray-100 cursor-not-allowed': !!props.editItem }"
                />
                <div v-if="!props.editItem" class="w-10 flex items-center justify-end">
                  <button v-if="idx === openingStockEntries.length - 1" type="button" @click="addOpeningEntry" class="h-6 w-6 flex items-center justify-center bg-green-500 text-white rounded-md text-xs font-bold">+</button>
                  <button v-else type="button" @click="removeOpeningEntry(idx)" class="h-6 w-6 flex items-center justify-center bg-red-500 text-white rounded-md text-xs font-bold">-</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Min Stock Level -->
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Min Stock Level</label>
            <input 
              v-model.number="form.minStock"
              type="number" 
              min="0.01"
              step="any"
             
              placeholder="0.00" 
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
              required
            >
          </div>

          <!-- Max Stock Level -->
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Max Stock Level</label>
            <input 
              v-model.number="form.maxStock"
              type="number" 
              min="0.01"
              step="any"
              
              placeholder="0.00" 
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
              required
            >
          </div>

          <!-- Shrinkage Cost -->
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Shrinkage Cost</label>
            <input 
              v-model.number="form.shrinkageCost"
              type="number" 
              placeholder="Enter cost" 
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
            >
          </div>

          <!-- Remark -->
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Remark</label>
            <textarea 
              v-model="form.remark"
              rows="1"
              placeholder="Remarks" 
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm resize-none"
            ></textarea>
          </div>
        </div>
        <div class="mt-2 flex justify-end">
          <label class="flex items-center gap-2 text-sm font-semibold text-[#1e293b] cursor-pointer">
            <input
              v-model="form.is_scannable"
              type="checkbox"
              class="h-4 w-4 accent-[#0d4169]"
            >
            Is Scannable
          </label>
        </div>

        <!-- Action Buttons -->
        <div class="mt-8 pt-6 border-t border-slate-100 flex justify-end gap-2 items-center">
            <button 
              type="button" 
              @click="closeModal" 
              class="px-4 py-2 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors"
            >
              Cancel
            </button>
            <button 
              type="submit" 
              :disabled="isSaving"
              class="px-6 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:transform active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              <div
                v-if="isSaving"
                class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
              ></div>
              <span>{{ isSaving ? 'Saving...' : 'Save Item' }}</span>
            </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, defineProps, defineEmits, watch, onMounted, ref, computed } from 'vue'
import { apiFetch } from '../../utils/api'
import store from '../../store'

const props = defineProps({
  isOpen: Boolean,
  editItem: Object
})

const emit = defineEmits(['close', 'save', 'update'])

const categories = ref([])
const units = [
  'liter',
  'K.G.',
  'Pieces',
 ]

const unitsProduction = [
  'M.L.',
  'Gram',
  'Pieces',
  'Bottle', 
  "Glass",
  'liter',
  'K.G.',
  'Pack',
]

const filteredUnitsProduction = computed(() => {
  return unitsProduction.filter(u => {
    if (['liter', 'K.G.', 'Pack'].includes(u)) {
      return u === form.unit || u === form.unitProduction
    }
    return true
  })
})

const unitsProductionOptions = computed(() => {
  let options
  if (['liter', 'K.G.'].includes(form.unit)) {
    options = ['M.L.', 'Gram', 'Glass']
  } else {
    options = filteredUnitsProduction.value
  }
  // Edit mode: keep disabled select aligned with stored unitProduction (e.g. Pack, Bottle).
  if (props.editItem && form.unitProduction && !options.includes(form.unitProduction)) {
    options = [...options, form.unitProduction]
  }
  return options
})

const currentUser = computed(() => store.getters.currentUser)
const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company?.id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch?.id || null)

const getInitialForm = () => ({
  itemCode: '',
  categoryId: '',
  itemName: '',
  unit: '',
  unitProduction: '',
  openingStock: 0,
  minStock: 0,
  maxStock: 0,
  shrinkageCost: null,
  remark: '',
  is_scannable: false,
  recentUnitPrice: null,
  grv_non_stockable_price: 0,
})

const form = reactive(getInitialForm())
const openingStockEntries = ref([{ balance: 0, unitPrice: 0, variant: 0, expiryDate: '' }])
const todayDate = new Date().toISOString().slice(0, 10)
const isSaving = ref(false)

// Fetch categories from DB
async function fetchCategories() {
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)
    
    const response = await apiFetch(`/categories?${params.toString()}`)
    if (response.ok) {
      categories.value = await response.json()
      categories.value = categories.value.filter(c => c.status === 1);
      categories.value.sort((a, b) => a.name.localeCompare(b.name))
    }
  } catch (error) {
    console.error('Error fetching categories:', error)
  }
}

function resolveEditUnitProduction(item) {
  if (!item) return ''
  if (item.unitProduction == '' || item.unitProduction == null) {
    return item.unit || ''
  }
  return item.unitProduction
}

watch(() => props.editItem, (newVal) => {
  if (newVal) {
    // Sync scalar fields (unit before unitProduction; unit watcher skips when editing)
    form.itemCode = newVal.itemCode || ''
    form.categoryId = newVal.categoryId || ''
    form.itemName = newVal.itemName || ''
    form.unit = newVal.unit || ''
    form.unitProduction = resolveEditUnitProduction(newVal)
    // keep legacy openingStock scalar
    form.openingStock = newVal.openingStock || 0

    // populate openingStockEntries from comma-separated backend fields if provided
    try {
      const balances = (newVal.openingStockBalances || '').toString().split(',').map(s => s.trim()).filter(s => s !== '')
      const prices = (newVal.openingStockUnitPrices || '').toString().split(',').map(s => s.trim()).filter(s => s !== '')
      const variants = (newVal.openingStockVariants || '').toString().split(',').map(s => s.trim()).filter(s => s !== '')
      const expiryDates = (newVal.openingStockExpiryDates || '').toString().split(',').map(s => s.trim()).filter(s => s !== '')

      const maxLen = Math.max(balances.length, prices.length, variants.length, expiryDates.length, 1)
      openingStockEntries.value = []
      for (let i = 0; i < maxLen; i++) {
        openingStockEntries.value.push({
          balance: balances[i] !== undefined ? parseFloat(balances[i]) || 0 : 0,
          unitPrice: prices[i] !== undefined ? parseFloat(prices[i]) || 0 : 0,
          variant: variants[i] !== undefined ? parseFloat(variants[i]) || 0 : 0,
          expiryDate: expiryDates[i] || ''
        })
      }
    } catch (e) {
      openingStockEntries.value = [{ balance: newVal.openingStock || 0, unitPrice: 0, variant: 0, expiryDate: '' }]
    }
    form.minStock = newVal.minStock || 0
    form.maxStock = newVal.maxStock || 0
    form.shrinkageCost = newVal.shrinkageCost || null
    form.remark = newVal.remark || ''
    form.is_scannable = newVal.is_scannable === true
    form.recentUnitPrice = newVal.recentUnitPrice || null
    form.grv_non_stockable_price = newVal.grv_non_stockable_price || 0
  } else {
    Object.assign(form, getInitialForm())
    openingStockEntries.value = [{ balance: 0, unitPrice: 0, variant: 0, expiryDate: '' }]
  }
}, { immediate: true })

onMounted(() => {
  if (props.isOpen) {
    fetchCategories()
  }
})

watch(() => props.isOpen, (isOpen) => {
  if (isOpen) {
    fetchCategories()
  }
})

function mapStockUomToProductionUom(stockUom) {
  if (!stockUom) return ''
  if (stockUom === 'liter') return 'M.L.'
  if (stockUom === 'K.G.') return 'Gram'
  if (stockUom === 'Pieces') return 'Pieces'
  return stockUom
}

// New registration only: derive U.O.M.Pro from U.O.M.Stock (field is disabled in UI)
watch(() => form.unit, (newUnit) => {
  if (props.editItem) return
  form.unitProduction = mapStockUomToProductionUom(newUnit)
})

function closeModal() {
  Object.assign(form, getInitialForm())
  openingStockEntries.value = [{ balance: 0, unitPrice: 0, variant: 0, expiryDate: '' }]
  emit('close')
}

function addOpeningEntry() {
  openingStockEntries.value.push({ balance: null, unitPrice: null, variant: null, expiryDate: '' })
}

function removeOpeningEntry(idx) {
  if (openingStockEntries.value.length <= 1) return
  openingStockEntries.value.splice(idx, 1)
}

// function onContinue(idx) {
//   // currently a placeholder: moves focus to next entry's balance (if exists) or adds new
//   if (idx === openingStockEntries.value.length - 1) addOpeningEntry()
// }

async function handleSubmit() {
  if (isSaving.value) return
  isSaving.value = true
  try {
    const itemNameTrimmed = String(form.itemName || '').trim()
    const itemCodeTrimmed = String(form.itemCode || '').trim()
    if (!itemNameTrimmed) {
      alert('Item Name is required.')
      return
    }

    if (!(Number(form.minStock) > 0)) {
      alert('Min Stock Level must be greater than 0.')
      return
    }
    if (!(Number(form.maxStock) > 0)) {
      alert('Max Stock Level must be greater than 0.')
      return
    }

    // Validation rule for opening stock rows:
    // - If opening balance is 0: unit price/volume can be 0 and expiry can be empty.
    // - If opening balance is not 0: unit price > 0, volume > 0, and expiry date is required.
    for (let i = 0; i < openingStockEntries.value.length; i++) {
      const entry = openingStockEntries.value[i]
      const balance = Number(entry?.balance || 0)
      const unitPrice = Number(entry?.unitPrice || 0)
      const volume = Number(entry?.variant || 0)
      const expiryDate = String(entry?.expiryDate || '').trim()

      if (balance !== 0) {
        if (!(unitPrice > 0)) {
          alert(`Opening stock row ${i + 1}: Unit Price must be greater than 0 when Opening Balance is not 0.`)
          return
        }
        if (!(volume > 0)) {
          alert(`Opening stock row ${i + 1}: Volume must be greater than 0 when Opening Balance is not 0.`)
          return
        }
        if (!expiryDate) {
          alert(`Opening stock row ${i + 1}: Expiry Date is required when Opening Balance is not 0.`)
          return
        }
      }
    }

    // prepare comma-separated opening stock fields
    // skip rows where all three values are empty/zero
    const cleanedEntries = openingStockEntries.value.filter(e => {
      const b = Number(e.balance || 0)
      const p = Number(e.unitPrice || 0)
      const v = Number(e.variant || 0)
      return b !== 0 || p !== 0 || v !== 0
    })

    const balances = cleanedEntries.map(e => (e.balance != null ? Number(e.balance) || 0 : 0))
    const prices = cleanedEntries.map(e => (e.unitPrice != null ? Number(e.unitPrice) || 0 : 0))
    const variants = cleanedEntries.map(e => (e.variant != null ? Number(e.variant) || 0 : 0))
    const expiryDates = cleanedEntries.map(e => e.expiryDate || '')

    // Calculate latest pricing snapshot from last opening-stock entry.
    let recentUnitPrice = null
    let recentVolume = null
    if (prices.length > 0) {
      const lastPrice = Number(prices[prices.length - 1]) || 0
      const lastVariant = variants.length > 0 ? Number(variants[variants.length - 1]) : null
      recentUnitPrice = lastPrice
      recentVolume = Number.isFinite(lastVariant) ? lastVariant : null
    }

    // Calculate grv_non_stockable_price from last unit price in opening stock
    let grv_non_stockable_price = 0
    if (prices.length > 0) {
      grv_non_stockable_price = parseFloat(prices[prices.length - 1]) || 0
    }

    const unitProductionForSave = props.editItem
      ? resolveEditUnitProduction(props.editItem)
      : form.unitProduction

    const payload = {
      // core item fields
      itemCode: itemCodeTrimmed || null,
      itemName: itemNameTrimmed,
      categoryId: form.categoryId || null,
      unit: form.unit,
      unitProduction: unitProductionForSave,

      // opening stock (detailed + legacy total)
      openingStockBalances: balances.join(','),
      openingStockUnitPrices: prices.join(','),
      openingStockVariants: variants.join(','),
      openingStockExpiryDates: expiryDates.join(','),
      openingStock: balances.reduce((s, v) => s + Number(v || 0), 0),

      // stock levels & costing
      minStock: form.minStock,
      maxStock: form.maxStock,
      shrinkageCost: form.shrinkageCost,
      remark: form.remark,
      is_scannable: form.is_scannable,

      // flags / audit
      ...(props.editItem ? {} : {
        is_ingredient: 0,
        recent_unit_price: recentUnitPrice,
        recent_volume: recentVolume,
        grv_non_stockable_price: grv_non_stockable_price,
      }),
      companyId: branchId.value ? null : companyId.value,
      branchId: branchId.value || null,
      [props.editItem ? 'updated_by' : 'created_by']: currentUser.value.id
    }

    let response
    if (props.editItem) {
      response = await apiFetch(`/items/${props.editItem.id}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
      })
    } else {
      response = await apiFetch('/items', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    }

    if (response.ok) {
      const savedItem = await response.json()
      if (props.editItem) {
        emit('update', savedItem)
      } else {
        emit('save', savedItem)
      }
      closeModal()
    } else {
      const err = await response.json()
      alert(err.message || 'Error saving item')
    }
  } catch (error) {
    console.error('Error submitting item:', error)
    alert('Network error')
  } finally {
    isSaving.value = false
  }
}
</script>

<style scoped>
.animate-in {
  animation: 0.2s ease-out forwards;
}
.fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
.zoom-in {
  from { transform: scale(0.95); }
  to { transform: scale(1); }
}
</style>
